export default __webpack_public_path__ + "static/media/Jeffrey.0ccfb5ef.png";